import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
 import axios from '../../../redux/axios';

const initialState = {
  viewAlluser: [],
  userCount:0,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getAllUsers = createAsyncThunk(
  'clerk/allUsers',
  async (page, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

    //   let response = await axios({
    //     url: '/api/api/clerk/allUsers',
    //     method: 'get',
    //     //timeout: 8000,
    //     headers: {
    //         //'Content-Type': 'application/json',
    //         "Authorization" : `Bearer ${tokenStr}`
    //     }
    // })

    let response = await axios({      
      url: '/api/clerk/allUsers?page='+page,
      method: 'get',
      //timeout: 8000,
      headers: {
          //'Content-Type': 'application/json',
          "Authorization" : `Bearer ${tokenStr}`
      }
  })
      
      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);




export const viewAlluserSlice = createSlice({
  name: 'userviewAll',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateAlluser: (state, {payload}) => { 
      //state.user = {};
      // state.isFetching = false;
      // state.isSuccess = false;
       state.isError = false;
       state.errorMessage = '';
    },
    getUserData: (state,{payload}) => {
      state.viewAlluser = payload.data.filteredUsers;
      state.userCount = payload.data.countObj.count;
      state.isFetching = false;
      state.isSuccess = true;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [getAllUsers.fulfilled]: (state, { payload }) => {
     
          state.viewAlluser = payload.data.filteredUsers;
          state.userCount = payload.data.countObj.count;
          state.isFetching = false;
          state.isSuccess = true;
          return state;
        },
        [getAllUsers.pending]: (state) => {
          state.isFetching = true;
        },
        [getAllUsers.rejected]: (state, { payload }) => {
          state.isFetching = false;
          state.isError = true;
          if(payload){
            state.errorMessage = payload.message;
          }
          else{
            state.errorMessage = 'Internal error';
          }
        }
    },
});

export const {clearStateAlluser,getUserData} = viewAlluserSlice.actions;


export const fetchUserData = (page) => async (dispatch, getState) => {
  try {
  const { auth } = getState()
   let tokenStr = auth.user.token;
   //const response = await axios.get('/api/user/list/detailed?page='+page,{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });
   let response = await axios({
    url: '/api/clerk/allUsers?page='+page,
    method: 'get',
    //timeout: 8000,
    headers: {
        //'Content-Type': 'application/json',
        "Authorization" : `Bearer ${tokenStr}`
    }
   });
    
    let data = response.data;
    if (response.status === 200) {
      return data;
    }
    else{
      return [];
    }

   //console.log(data)
   //dispatch(getUserData(data));
  } catch (error) {
    //dispatch(updateDepartment(error.response.data));
  }
};

export function clearState() {
  
  return async (dispatch) => {
    dispatch(clearStateAlluser());
  }
}

export const viewAlluserSelector = (state) => state.frontviewallusers ;

export default viewAlluserSlice.reducer;
